document.addEventListener('DOMContentLoaded', function () {
    const input = document.querySelector('.footer-input-newsletter');
    const button = document.querySelector('.footer-button-newsletter');

    if (!input || !button) {
      return;
    }

    input.addEventListener('input', function () {
      if (input.value.trim() !== '') {
        button.classList.add('active');
        button.disabled = false;
      } else {
        button.classList.remove('active');
        button.disabled = true;
      }
    });
  });